import { css } from '@lastbrand/web-ui-styled-system/css'

// Layout only — the inter-option gap is applied separately (optionListGapClass / optionListGapPdpClass)
// so PDP/QATC can swap row vs column gaps. Every consumer must pair this with a gap class.
export const optionListWrapperClass = css({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
})

export const optionListGapClass = css({ gap: 'space-8' })
export const optionListGapPdpClass = css({ paddingTop: 'space-12', columnGap: 'space-8', rowGap: 'space-16' })

export const optionWrapperClass = css({
  display: 'flex',
})

export const packOptionWrapperClass = css({
  // full width on mobile, auto from `lg` up.
  width: { base: '100%', lg: 'auto' },
})

export const engravingOptionWrapperClass = css({
  flexGrow: 1,
})

export const optionNameClass = css({
  marginTop: 'space-2',
})

export const excessElementsClass = css({
  display: 'flex',
  alignItems: 'center',
  textStyle: 'body-14',
})

// Pointer cursor only when the +N control is actually clickable (a handler is wired).
export const excessElementsInteractiveClass = css({
  cursor: 'pointer',
})
